import { useFetchConnectedChildren } from "seneca-common/features/parents/features/parent/service/hooks/useFetchChildConnections";
import { isSignedIn } from "seneca-common/features/user/state";
import { useSelector } from "seneca-common/utils/hooks/selectors";

import { getChildUserId } from "features/parents/features/ui-state/state";

export function useGetSelectedChildUserId() {
  const isUserSignedIn = useSelector(isSignedIn);
  const selectedChildId = useSelector(getChildUserId);

  const { data: children = [] } = useFetchConnectedChildren({
    enabled: isUserSignedIn
  });
  const childrenIds = children.map(child => child.userId);

  const childId = childrenIds.includes(selectedChildId)
    ? selectedChildId
    : null;

  return childId || childrenIds[0];
}
